import $ from 'sbf-design-system/js/jquery';

$(document).ready(() => {
  $('.sbf-broadcast-message__close').click(function () {
    hideBroadcastMessage($(this).closest('.sbf-broadcast-message'));
  });

  const setCookie = (name, value) => {
    const maxAge = 7 * 24 * 60 * 60;
    const encodedName = encodeURIComponent(name);
    const encodedValue = encodeURIComponent(value);
    document.cookie = `${encodedName}=${encodedValue};path=/;max-age=${maxAge};SameSite=Strict`;
  };

  const hideBroadcastMessage = (message) => {
    message.addClass('js-hide');
    setCookie(message.data('cookie-key'), 'dismissed');
  }
});